import { computed, onMounted, onUnmounted, reactive, ref, watch } from 'vue';

const layoutConfig = reactive({
    preset: 'Aura',
    primary: 'blue',
    surface: null,
    darkTheme: false,
    menuMode: 'static',
    menuState: 'expanded',
    anchored: false,
    configSidebarVisible: false
});

export function useLayout() {
    const windowWidth = ref(window.innerWidth);

    const updateWindowWidth = () => {
        windowWidth.value = window.innerWidth;
    };

    onMounted(() => {
        window.addEventListener('resize', updateWindowWidth);
    });

    onUnmounted(() => {
        window.removeEventListener('resize', updateWindowWidth);
    });

    const setMenuMode = (mode) => {
        layoutConfig.menuMode = mode;
    };

    const setMenuState = (state) => {
        layoutConfig.menuState = state;
        if (calculatedMenuMode.value === 'drawer' || calculatedMenuMode.value === 'reveal') {
            layoutConfig.anchored = false;
        }
    };

    const toggleMenuState = () => {
        const newState = layoutConfig.menuState === 'expanded' ? 'collapsed' : 'expanded';
        setMenuState(newState);
    };

    const onClose = () => {
        layoutConfig.menuState = 'collapsed';
    };

    const toggleAnchored = () => {
        const newValue = !layoutConfig.anchored;
        layoutConfig.anchored = newValue;
        if (newValue) {
            layoutConfig.menuState = 'expanded';
        } else {
            layoutConfig.menuState = 'collapsed';
        }
    };
    const toggleConfigSidebar = () => {
        if (layoutConfig.menuState === 'expanded' && calculatedMenuMode.value === 'overlay') {
            layoutConfig.menuState = 'collapsed';
        }

        layoutConfig.configSidebarVisible = !layoutConfig.configSidebarVisible;
    };
    const isDarkTheme = computed(() => layoutConfig.darkTheme);
    const isDesktop = computed(() => windowWidth.value >= 992);
    const isMobile = computed(() => windowWidth.value < 992);
    const menuMode = computed(() => layoutConfig.menuMode);
    const menuState = computed(() => layoutConfig.menuState);
    const calculatedMenuMode = computed(() => (isMobile.value ? 'overlay' : layoutConfig.menuMode));

    watch(
        calculatedMenuMode,
        (newMode) => {
            if (['overlay', 'reveal', 'drawer'].includes(newMode)) {
                setMenuState('collapsed');
            } else {
                setMenuState('expanded');
            }
        },
        { immediate: true }
    );

    return {
        layoutConfig,
        isDarkTheme,
        setMenuMode,
        setMenuState,
        toggleMenuState,
        onClose,
        toggleAnchored,
        toggleConfigSidebar,
        isDesktop,
        isMobile,
        menuMode,
        menuState,
        calculatedMenuMode
    };
}
